const segmentContainer = "flex flex-col items-center gap-1.5 min-w-[80px]";

const segmentCircle = "rounded-full flex items-center justify-center text-xs font-medium transition-all duration-200";

const segmentCircleCompleted = "h-8 w-8 bg-primary text-primary-foreground shadow-md";

const segmentCircleActive =
  "h-9 w-9 bg-gradient-to-br from-primary to-primary/70 text-primary-foreground shadow-lg ring-2 ring-primary/30 ring-offset-2 ring-offset-background";

const segmentCirclePending = "h-8 w-8 bg-background border-2 border-border text-muted-foreground";

const segmentLabel = "text-xs text-muted-foreground transition-colors duration-200";

const segmentLabelActive = "text-foreground font-medium";

const progressBarContainer = "h-[2px] w-full max-w-[60px]";

const progressBarCompleted = "h-full w-full bg-primary rounded-full";

const progressBarActive = "relative h-full w-full bg-border rounded-full overflow-hidden";

const progressBarActiveFill = "absolute left-0 top-0 h-full w-1/2 bg-primary rounded-full";

const progressBarPending = "h-full w-full bg-border rounded-full";

const iconTextPrimary = "text-primary-foreground";

export {
  segmentContainer,
  segmentCircle,
  segmentCircleCompleted,
  segmentCircleActive,
  segmentCirclePending,
  segmentLabel,
  segmentLabelActive,
  progressBarContainer,
  progressBarCompleted,
  progressBarActive,
  progressBarActiveFill,
  progressBarPending,
  iconTextPrimary,
};
